<script>
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
export default {
  mixins: [Api, Sabit],
  props: ["Id"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "999",
        PageDataSize: "1",
      },
      FormData: {},
      TableData:{}
    };
  },
  components: {
    Loader,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.Get();
    },
  },
  methods: {
    Get() {
       let Filter = "&Birimbutceharcamalariid=" + this.FormData.Id;
      this.ActionsFilterGet({Service:"StrBirimButceHarcamalariTutarlari",Page:this.Page,Filter:Filter}).then((res) => {
        this.TableData = res.Data; 
      });
    },
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrBirimButceHarcamalariYazdir"
      size="lg"
      :title="$t('StrBirimButceHarcamalari.Print.Title')"
      title-class="font-18"
      hide-footer
    >
      <div class="row">  
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button
                      type="button"
                      class="btn btn-success btn-rounded mb-2 me-2"
                      @click="ExcelExport('Harcama Giriş', 'Harcama Giriş')"
                    >
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      {{ $t("StrBirimButceHarcamalari.Print.ExceleAktar") }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-warning btn-rounded mb-2 me-2"
                      @click="
                        Export2Word('exportContent', 'Harcama Giriş')
                      "
                    >
                      <i class="mdi mdi-file-export-outline me-1"></i>

                      {{ $t("StrBirimButceHarcamalari.Print.WordeAktar") }}
                    </button>
                  </div>
                </div>
              </div>

              <div id="exportContent"> 
                <div class="table-responsive" ref="ExcelExportTable">
                  <table
                    class="table table-borderless mb-0"
                    style="border-collapse: collapse; width: 100%"
                  >
                    <thead>
                      <tr>
                        <th :colspan="4" class="text-sm-center">
                          STRATEJİKPLAN-PERFORMANS PROGRAMI-BÜTÇE-HARCAMA
                          İLİŞKİLENDİRME TABLOSU
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="border: 1px solid" :colspan="2">
                          Harcama Birimi Adı
                        </td>
                        <td style="border: 1px solid" :colspan="2">
                          {{ FormData.BirimAdi }}
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid">Belge Tarih</td>
                        <td style="border: 1px solid">
                          {{ FormData.Tarih | formatDateTable }}
                        </td>
                        <td style="border: 1px solid">Sayı</td>
                        <td style="border: 1px solid">{{ FormData.Donem }}/{{ FormData.Sira }}</td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid" rowspan="6">
                          Stratejik Plan Performans Programı Bütçe İlişkisi
                        </td>
                        <td style="border: 1px solid" rowspan="2">
                          Stratejik Plan Bilgileri
                        </td>
                        <td style="border: 1px solid">Bütçe Yılı</td>
                        <td style="border: 1px solid">{{ FormData.Donem }}</td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid">Dönemi</td>
                        <td style="border: 1px solid"  >
                          {{ FormData.DonemAdi }}
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid" rowspan="3">
                          Performans Programı Bilgileri
                        </td>
                        <td style="border: 1px solid">Stratejik Amaç</td>
                        <td style="border: 1px solid" >
                          {{ FormData.Amac }}
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid">Performans Hedefi</td>
                        <td style="border: 1px solid"  >
                          {{ FormData.PerformansHedefi }}
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid">Faaliyet Adı</td>
                        <td style="border: 1px solid" > {{  FormData.FaliyetAdi }}</td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid">Tertibi</td>
                        <td style="border: 1px solid" colspan="2"> 
                           <table
                            class="table table-borderless mb-0"
                            style="border-collapse: collapse; width: 100%"
                          >
                            <tbody>
                              <tr v-for="Data in TableData"
              :key="Data.Id">
                                <td  style="border: 1px solid" class="text-sm-center"> 
                                  {{ Data.HesapKodAciklama }}
                                </td>
                                <td  style="border: 1px solid" class="text-sm-center"> 
                                   {{ Data.Tutar | TrParaFormat }}
                                </td>
                              </tr>
                            </tbody>
                           </table>
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid" colspan="2">
                          Harcamaya ilişkin Bilgiler
                        </td>
                        <td style="border: 1px solid" colspan="2">
                          {{ FormData.Aciklama }}
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid" colspan="2">
                          İhale Usulü
                        </td>
                        <td style="border: 1px solid" colspan="2">
                          {{ FormData.IhaleUsulleriValue }}
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid" colspan="4">
                          Harcamayailişkin bilgiler kısmındaaçıklanan
                          giderin;stratejik plan, performans programı ve
                          bütçeilişkisi yukarıda belirtildiği gibidir
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid" colspan="2">
                          Veri Girişi Yapan
                        </td>
                        <td style="border: 1px solid" colspan="2">
                          Gerçekleştirme Görevlisi
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid" colspan="2">
                          {{ FormData.HarcamaYetkilisiAdi + " " +FormData.HarcamaYetkilisiSoyAdi }}
                        </td>
                        <td style="border: 1px solid" colspan="2">
                          {{ FormData.GerceklestirmeGorevlisiAdi + " " +FormData.GerceklestirmeGorevlisiSoyAdi }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Loader>
</template>
